import SectionHeader, { SectionHeaderProps } from './SectionHeader';

export type { SectionHeaderProps };
export default SectionHeader;
